/**
 * Greyscale RGBA through a window, `lower` black and `upper` white unless
 * `inverted`. A non-finite value is transparent, so it reads as absence.
 * @throws if the window is empty or not finite.
 */
export function windowedGreyscaleRgba(
    values: ArrayLike<number>,
    lower: number,
    upper: number,
    inverted = false
): Uint8ClampedArray {
    if (!(Number.isFinite(lower) && Number.isFinite(upper) && upper > lower)) {
        throw new Error(
            `windowedGreyscaleRgba: invalid window [${lower}, ${upper}]`
        );
    }
    const scale = 255 / (upper - lower);
    const rgba = new Uint8ClampedArray(values.length * 4);
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (!Number.isFinite(value)) {
            continue;
        }
        const level = (value - lower) * scale;
        const grey = inverted ? 255 - level : level;
        const offset = i * 4;
        rgba[offset] = grey;
        rgba[offset + 1] = grey;
        rgba[offset + 2] = grey;
        rgba[offset + 3] = 255;
    }
    return rgba;
}
